import RegistrationStep1 from './RegistrationStep1';
import RegistrationStep2 from './RegistrationStep2';
import RegistrationStep3 from './RegistrationStep3';
import RegistrationStep4 from './RegistrationStep4';
import RegistrationStep5 from './RegistrationStep5';
import RegistrationStep6 from './RegistrationStep6';
import RegistrationStep7 from './RegistrationStep7';
import RegistrationStep8 from './RegistrationStep8/RegistrationStep8';
import RegistrationStep9 from './RegistrationStep9';

export const registrationFormSteps = [
	RegistrationStep1,
	RegistrationStep2,
	RegistrationStep3,
	RegistrationStep4,
	RegistrationStep5,
	RegistrationStep6,
	RegistrationStep7,
	RegistrationStep8,
	RegistrationStep9,
];
